import { useTranslation } from "react-i18next";

import { useRunFlat } from "./useRunFlat";

const defaultOptions: Option[] = [
  { checked: false, label: "showRunFlat", value: "1" },
  { checked: false, label: "showNonRunFlat", value: "0" },
];

export const useRunFlatOptions = (): Option[] => {
  const [selectedOptions] = useRunFlat();
  const { t } = useTranslation();

  const options = defaultOptions.map(({ label, value }) => ({
    checked: selectedOptions.includes(value),
    label: t(`searchResults.${label}`),
    value,
  }));
  return options;
};

type Option = {
  checked: boolean;
  label: string;
  value: string;
};
